export default "/images/vendor/flag-icon-css/flags/1x1/jo.svg?e678dae866ec74e6a939083ea4223eac";